<template>
  <div>
    <top-bar />
    <router-view class="content" />
  </div>
</template>

<script>
import TopBar from "@/components/common/TopBar";

export default {
  components: {
    "top-bar": TopBar
  }
};
</script>

<style scoped>
.content {
  width: 100%;
  min-height: 90vh !important;
  box-sizing: border-box;
}
</style>
